var React = require('react');

function Box (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z","key":0}),React.createElement("polyline",{"points":"3.27 6.96 12 12.01 20.73 6.96","key":1}),React.createElement("line",{"x1":"12","y1":"22.08","x2":"12","y2":"12","key":2})]);
}

Box.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-box"};

module.exports = Box;

Box.default = Box;
